<app-nav-bar></app-nav-bar>
<app-side-bar></app-side-bar>
<app-settings-modal></app-settings-modal>
<!-- <div class="container method-btns">
  <button type="button" class="btn btn-outline-primary" (click)="enableInputs()" *ngIf="product.id > 0"
    [hidden]="inputModifyHidden">
    Modificar producto
  </button>
  <button type="button" class="btn btn-outline-primary" (click)="cleanAll(); enableInputs()" *ngIf="product.id > 0">
    Crear nuevo producto
  </button>
</div> -->

<div class="container">
  <div class="loading" *ngIf="loading">
    <div class="spinner-border" role="status"></div>
  </div>
  <div class="container-inventory" *ngIf="!loading">
    <div class="header">
      <h1 class="title">{{'NEW_PRODUCT'  | translate}}</h1>
      <app-back-arrow [route]="'/products'"></app-back-arrow>
    </div>

    <div class="container-product-type">
      <div class="form-card" *ngIf="this.themingService.shopTheming[0].shopSubscription.shopProductTypesAllow.split(',').length > 1">
        <!-- <h1 class="subtitle"> {{'PRODUCT_TYPE' | translate}}</h1> -->
        <label class="form-label"> {{'PRODUCT_TYPE' | translate}}</label>
        <div class="form-group-container top-container">
          <div class="form-group trio" *ngIf="isProductTypeAllowed(1)">
            <div class="form-check form-control-lg">
              <input class="form-check-input radio-type" type="radio" name="product-type" id="productType" value="1" (change)="changeProductType($event)" [checked]="getDefaultProdType(1)">
              <label class="form-check-label">
                {{'CONVENTIONAL_PRODUCT' | translate}}
              </label>
            </div>
          </div>
          <div class="form-group trio" *ngIf="isProductTypeAllowed(2)">
            <div class="form-check form-control-lg">
              <input class="form-check-input radio-type" type="radio" name="product-type" id="productType" value="2" (change)="changeProductType($event)" [checked]="getDefaultProdType(2)">
              <label class="form-check-label">
                {{'SESSIONS_PRODUCT' | translate}}
              </label>
            </div>
          </div>
          <div class="form-group trio" *ngIf="isProductTypeAllowed(3)">
            <div class="form-check form-control-lg">
              <input class="form-check-input radio-type" type="radio" name="product-type" id="productType" value="3" (change)="changeProductType($event)" [checked]="getDefaultProdType(3)">
              <label class="form-check-label">
                {{'INSURANCE_PRODUCT' | translate}}
              </label>
            </div>
          </div>
          <div class="form-group trio" *ngIf="isProductTypeAllowed(4)">
            <div class="form-check form-control-lg">
              <input class="form-check-input radio-type" type="radio" name="product-type" id="productType" value="4" (change)="changeProductType($event)" [checked]="getDefaultProdType(4)">
              <label class="form-check-label">
                 {{'PACKAGE_PRODUCT' | translate}}
              </label>
            </div>
          </div>
        </div>
      </div>

    <div class="form-card">
      <input type="hidden" id="product_id" name="id" value="{{product.id}}" />

      <!-- <div class="form-label">Imágenes:</div>
      <div class="images-container">
        <div cdkDropList cdkDropListOrientation="horizontal" class="image-list" (cdkDropListDropped)="drop($event)">
          <div class="image-box" *ngFor="let image of productImages.small; let i = index" [cdkDragDisabled]="false"
            cdkDrag>
            <div class="image-placeholder" *cdkDragPlaceholder></div>
            <img [src]="image.imageURL" />
            <button type="button" class="btn btn-danger delete-button" (click)="deletePhoto(i)">
              x
            </button>
            <button type="button" class="btn btn-link download-button" (click)="downloadImage(i)">
              <i class="feather" data-feather="download"></i>
            </button>
          </div>
          <div class="image-box" cdkDragDisabled>
            <button class="add-img" (click)="uploadImage()">+</button>
          </div>
        </div>
      </div> -->

      <div class="form-group-container">
        <div class="form-group couple">
          <label class="form-label is-required" for="product_name">{{'NAME' | translate}}</label>
          <input type="text" class="form-control" id="product_name" name="name" placeholder="{{'PRODUCT_NAME' | translate}}"
            value="{{product.name}}" (keyup)="changeName($event)" [disabled]="inputsDisabled" />
        </div>

        <div class="form-group couple">
          <label class="form-label is-required" for="product_code">{{'CODE' | translate}}</label>
          <input type="text" class="form-control" id="product_code" name="code" placeholder="{{'PRODUCT_CODE' | translate}}"
            value="{{product.code}}" (keyup)="changeCode($event)" [disabled]="inputsDisabled" />
        </div>
      </div>

      <div class="form-group-container">
        <div class="form-group trio">
          <label class="form-label is-required" for="product_category"> {{'CATEGORIES' | translate}}</label>
          <select class="form-select" id="product_category" name="category" (change)="changeCategory($event)">
            <option selected disabled hidden>{{'SELECT_CATEGORY' | translate}}</option>
            <option *ngFor="let category of categories" [value]="category.categoryId">
              {{ category.categoryName }}
            </option>
          </select>
        </div>
        <div class="form-group trio">
          <label class="form-label" for="product_subcategory">{{'SUBCATEGORY' | translate}}</label>
          <select class="form-select" id="product_subcategory" name="subcategory" (change)="changeSubCategory($event)"
            [disabled]="!subCategories || subCategories.length === 0">
            <option value="0">{{'SELECT_SUBCATEGORY' | translate}}</option>
            <ng-container *ngIf="subCategories && subCategories.length > 0; else noSubCategories">
              <option *ngFor="let subCategory of subCategories" [value]="subCategory.subCategoryId">
                {{ subCategory.subCategoryName }}
              </option>
            </ng-container>
            <ng-template #noSubCategories>
              <option disabled selected hidden>{{'NO_SUBCATEGORIES' | translate}}</option>
            </ng-template>
          </select>
        </div>

        <div class="form-group trio">
          <label class="form-label" for="product_subsubcategory">{{'SUB_SUBCATEGORY' | translate}}</label>
          <select class="form-select" id="product_subsubcategory" name="subsubcategory" (change)="changeSubSubCategory($event)"
            [disabled]="!subSubCategories || subSubCategories.length === 0">
            <option value="0">{{'SELECT_SUB_SUBCATEGORY' | translate}}</option>
            <ng-container *ngIf="subSubCategories && subSubCategories.length > 0; else noSubSubCategories">
              <option *ngFor="let subSubCategory of subSubCategories" [value]="subSubCategory.subSubCategoryId">
                {{ subSubCategory.subSubCategoryName }}
              </option>
            </ng-container>
            <ng-template #noSubSubCategories>
              <option disabled selected hidden> {{'NO_SUB_SUBCATEGORIES' | translate}}</option>
            </ng-template>
          </select>
        </div>
      </div>

      <div class="form-group-container">
      <div class="form-group couple">
        <label class="form-label is-required" for="product_industryType">{{'INDUSTRY' | translate}}</label>
        <select class="form-select " id="product_industryType" name="industryType" (change)="changeIndustry($event)"
          [disabled]="inputsDisabled">
          <option selected disabled hidden> {{'SELECT_INDUSTRY' | translate}}</option>
          <option *ngFor="let industryType of industryTypes" [value]="industryType.industryTypeId">
            {{ industryType.industryTypeName }}
          </option>
        </select>
      </div>
      <div class="form-group couple">
        <div><label class="form-label" for="product_status"> {{'STATUS' | translate}}</label></div>
        <div class="switch">
          <label class="switch-label">
            <input type="checkbox"id="product_status" name="status" [disabled]="inputsDisabled" [(ngModel)]="isChecked"/>
            <span class="slider round"></span>
          </label>
        </div>
        <div><span id="statusText" class="status-text">{{ isChecked ? ('ACTIVE' | translate) : ('INACTIVE' | translate) }}</span></div>
      </div>
      </div>

      <div class="form-group-container">
        <div class="form-group couple" *ngIf="true">
          <label class="form-label" for="product_supplier">{{'SUPPLIER'| translate}}</label>
          <select class="form-select" id="product_supplier" name="supplier" (change)="changeSupplier($event)"
            [disabled]="inputsDisabled">
            <option selected disabled hidden> {{'SELECT_SUPPLIER' | translate}}</option>
            <option *ngFor="let supplier of suppliers" [value]="supplier.supplierId">
              {{ supplier.supplierName }}
            </option>
          </select>
        </div>

        <div class="form-group couple" *ngIf="true">
          <label class="form-label" for="product_collection">{{'COLLECTION' | translate}}</label>
          <select class="form-select" id="product_collection" name="collection" (change)="changeCollection($event)"
            [disabled]="inputsDisabled">
            <option selected disabled hidden> {{'SELECT_COLLECTION' | translate}}</option>
            <option *ngFor="let collection of collections" [value]="collection.collectionId">
              {{ collection.collectionName }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group-container" *ngIf="canUseExternalRedirect  && productType == 1">
        <div class="form-group couple external-url-group">
          <label class="form-label" for="external_url">{{"EXTERNAL_PRODUCT_URL" | translate}}</label>
 
          <input
            type="text"
            class="form-control"
            id="external_url"
            name="external_url"
            placeholder="https://example.com/product"
            [value]="product.externalUrl || ''"
            [disabled]="!product.externalRedirectEnabled"
            [ngClass]="{'is-invalid': showExternalUrlInvalid()}"
            (input)="onExternalUrlChange($event)"
          />
          <div class="d-flex flex-column justify-space-between">
            <small class="text-danger" *ngIf="showExternalUrlInvalid()">
               {{'INVALID_URL_FORMAT' | translate}}
            </small>
            <small class="text-muted">
              {{'EXTERNAL_URL_INFO' | translate}}
            </small>
          </div>
        </div>
        <div class="form-group couple external-redirect-toggle">
          <div class="form-check mt-4">
            <input
              class="form-check-input"
              type="checkbox"
              id="external_redirect_enabled"
              name="external_redirect_enabled"
              [checked]="product.externalRedirectEnabled"
              (change)="onExternalRedirectToggle($event)"
            />
            <label class="form-check-label" for="external_redirect_enabled">
              {{"ENEABLE_EXTERNAL_REDIRECT" | translate}}
            </label>
          </div>
        </div>
      </div>

      <div class="form-group-container">
        <div class="form-group-pdf pdf-uploader">
          <label for="pdfInput" class="form-label">{{'UPLOAD_PDF' | translate}}</label>
          <div class="input-group">
            <input
              type="file"
              class="form-control"
              id="pdfInput"
              accept="application/pdf"
              (change)="onFileSelected($event)"
            />
          </div>
          <div class="file-preview" *ngIf="pdfFileName">
            <!-- <span class="badge bg-primary">{{ pdfFileName }}</span> -->
          </div>
          <small class="text-muted" *ngIf="!pdfFileName">{{'SELECT_PDF' | translate}} <strong>{{'MAX_SIZES' | translate}}</strong></small>
         </div>

         <div class="form-group couple">
          <button
          class="btn btn-outline-secondary submit-btn"
          (click)="openPdfInNewTab()"
          [disabled]="!pdfSrc"
        >
          {{'VIEW_PDF' | translate}}
        </button>
         </div>
      </div>

      <!-- <div class="form-group-container" *ngIf="productType == 2 || productType == 4">
        <div class="form-group trio">
          <label class="form-label is-required" for="product_sessions">{{'SESSIONS' | translate}}</label>
          <input type="number" min="0" class="form-control" id="product_sessions" name="name" placeholder="Cantidad de sesiones" value="{{product.sessions}}" (keyup)="changeSessions($event)"/>
        </div>
        <div class="form-group trio">

        </div>
      </div> -->
      <div class="form-group-container">
        <div class="form-group couple" *ngIf="productType == 2">
            <label class="form-label is-required" for="product_grace_period"> {{'GRACE_PERIOD' | translate}}</label>
            <input class="form-control" id="product_grace_period" name="gracePeriod" placeholder="0" value="0" (input)="changeGracePeriod($event)" type="number" min="0"/>
          </div>
      </div>

      <div class="info-container description">
        <div class="form-label mt-5" for="product_description">{{'DESCRIPTION' | translate}}:</div>
        <div class="description-card ql-editor p-0" id="description"></div>
      </div>
      <!-- [customOptions]="customOptions" -->
      <quill-editor class="description-editor"
        [styles]="{ borderRadius: '0 0 10px 10px', padding: '5px', marginBottom: '2vh' }"
        [theme]="'snow'"
        id="description-edit"
        [modules]="modules"t
        (onEditorCreated)="setQuillInstance($event,'description')"
        (onEditorChanged)="descriptionChanged($event)">
      </quill-editor>

      <div class="info-container description">
        <div class="form-label mt-5" for="product_conditions">Condiciones:</div>
        <div class="description-card ql-editor p-0" id="conditions"></div>
      </div>
      <!-- [customOptions]="customOptions" -->
      <quill-editor class="conditions-editor"
        [styles]="{ borderRadius: '0 0 10px 10px', padding: '5px', marginBottom: '2vh' }"
        [theme]="'snow'"
        id="conditions-edit"
        [modules]="modules"t
        (onEditorCreated)="setQuillInstance($event,'conditions')"
        (onEditorChanged)="conditionsChanged($event)">
      </quill-editor>

    <div class="form-card" *ngIf="productType === 4">
      <h1 class="title">{{ 'ADD_PRODUCT_TO_PACKAGE' | translate }}</h1>
      <div class="row g-2 mb-3">
        <div class="d-flex align-items-center justify-content-between mt-3">
          <label class="form-label">{{ 'FILTERS' | translate }}:</label>
          <div class="col-md-2 d-flex align-items-center mt-3">
            <div class="form-check form-switch">
              <input
                #chk
                class="form-check-input"
                type="checkbox"
                id="chkActive"
                [checked]="filters.onlyActive"
                (change)="toggleOnlyActive(chk.checked)"
              />
              <label class="form-check-label" for="chkActive">{{ 'ACTIVE_ONLY' | translate }}</label>
            </div>
          </div>
        </div>

        <!-- FILTERS -->
        <div class="row g-2">
          <div class="col-md-2 form-floating">
            <input
              type="text"
              class="form-control w-100"
              id="txtSearch"
              placeholder="Buscar"
              (input)="onSearchChange($any($event.target).value)"
            />
            <label for="txtSearch">🔍 Buscar</label>
          </div>
            <div class="col-md-2 form-floating">
              <select class="form-select w-100" id="selCat"
                      [(ngModel)]="filters.categoryId"
                      (ngModelChange)="onCategoryChange($event)"
                      [ngModelOptions]="{standalone: true}">
                <option [ngValue]="0">{{ 'ALL' | translate }}</option>
                <option *ngFor="let c of categories" [ngValue]="c.categoryId">{{ c.categoryName }}</option>
              </select>
              <label for="selCat">{{ 'CATEGORY' | translate }}</label>
            </div>
            <div class="col-md-2 form-floating">
              <select class="form-select w-100" id="selSubCat"
                      [disabled]="subCategoriesForFilters.length===0"
                      [(ngModel)]="filters.subCategoryId"
                      (ngModelChange)="onSubCategoryChange($event)"
                      [ngModelOptions]="{standalone: true}">
                <option [ngValue]="0">{{ 'ALL' | translate }}</option>
                <option *ngFor="let s of subCategoriesForFilters" [ngValue]="s.subCategoryId">{{ s.subCategoryName }}</option>
              </select>
              <label for="selSubCat">{{ 'SUBCATEGORY' | translate }}</label>
            </div>
            <div class="col-md-2 form-floating mt-2">
              <select class="form-select w-100" id="selSubSubCat"
                      [disabled]="subSubCategoriesForFilters.length===0"
                      [(ngModel)]="filters.subSubCategoryId"
                      (ngModelChange)="onSubSubCategoryChange($event)"
                      [ngModelOptions]="{standalone: true}">
                <option [ngValue]="0">{{ 'ALL' | translate }}</option>
                <option *ngFor="let s of subSubCategoriesForFilters" [ngValue]="s.subSubCategoryId">{{ s.subSubCategoryName }}</option>
              </select>
              <label for="selSubSubCat">{{ 'SUB_SUBCATEGORY' | translate }}</label>
            </div>
            <div class="col-md-2 form-floating mt-2">
              <select class="form-select w-100" id="selCollection"
                      [(ngModel)]="filters.collectionId"
                      (ngModelChange)="onCollectionChange($event)"
                      [ngModelOptions]="{standalone: true}">
                <option [ngValue]="0">{{ 'ALL' | translate }}</option>
                <option *ngFor="let col of collections" [ngValue]="col.collectionId">{{ col.collectionName }}</option>
              </select>
              <label for="selCollection">{{ 'COLLECTION' | translate }}</label>
            </div>
            <div class="col-md-2 form-floating mt-2">
              <select class="form-select w-100" id="selSupplier"
                      [(ngModel)]="filters.supplierId"
                      (ngModelChange)="onSupplierChange($event)"
                      [ngModelOptions]="{standalone: true}">
                <option [ngValue]="0">{{ 'ALL' | translate }}</option>
                <option *ngFor="let sup of suppliers" [ngValue]="sup.supplierId">{{ sup.supplierName }}</option>
              </select>
              <label for="selSupplier">{{ 'SUPPLIER' | translate }}</label>
            </div>
        </div>
      </div>

     <div class="d-flex justify-content-between">
        <div class="mt-2 col-md-8">
          <ng-container *ngIf="selected.length; else noTags">
            <span *ngFor="let s of selected" class="badge m-2 bg-primary p-2">
              {{ s.productName }}
              <button
                type="button"
                class="btn-close btn-close-white btn-sm ms-1"
                aria-label="Remove"
                (click)="toggleProduct(s)">
              </button>
            </span>
          </ng-container>
          <ng-template #noTags></ng-template>
        </div>
        <div class="d-flex align-items-center justify-content-end col-md-4">
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-success"
                    (click)="showProducts()" [disabled]="filterLoading">
              {{ 'SHOW_PRODUCTS' | translate}}
            </button>
            <button type="button" class="btn btn-outline-secondary"
                    (click)="resetFilters()" [disabled]="filterLoading">
              {{ 'RESET_FILTERS' | translate}}
            </button>
          </div>
        </div>
      </div>
      <span class="badge w-auto col-md-2 bg-secondary">
        {{ productPackageItems.length }} {{ 'SELECTED' | translate }}
      </span>

      <hr class="mt-3" />

      <div *ngIf="filtersUsed && !filterLoading" class="d-flex align-items-center gap-2 mb-3">
        <label class="form-label mb-0">{{ 'SHOW' | translate }}:</label>
        <select
          class="form-select mb-0 w-auto"
          [(ngModel)]="filters.amount"
          (change)="changePageSize()"
        >
          <option [value]="1">1</option>
          <option [value]="5">5</option>
          <option [value]="10">10</option>
          <option [value]="25">25</option>
          <option [value]="50">50</option>
          <option [value]="100">100</option>
        </select>

        <span class="ms-3">
          {{ total }} {{ 'RESULT' | translate }}{{ total === 1 ? '' : 's' }} ·
          {{ totalPages }} {{ 'PAGE' | translate }}{{ totalPages === 1 ? '' : 's' }}
        </span>
      </div>

      <div class="text-center my-3" *ngIf="filterLoading">
        <div class="spinner-border text-secondary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <table class="table table-hover align-middle" *ngIf="filtersUsed && !filterLoading">
        <thead class="table-light">
          <tr>
            <th style="width:48px"></th>
            <th>{{ 'NAME' | translate }}</th>
            <th>{{ 'CODE' | translate }}</th>
            <th>{{ 'PRICE' | translate }}</th>
            <th>{{ 'IMAGE' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of catalog">
            <td class="text-center">
              <input
                type="checkbox"
                class="form-check-input"
                [checked]="isSelected(p.productId)"
                (change)="toggleProduct(p)"
              />
            </td>
            <td>{{ p.productName }}</td>
            <td>{{ p.productCode }}</td>
            <td>
              {{ currency }}{{ p.productSellPrice || 0 }}
              <span *ngIf="p.discountPrice > 0" class="text-decoration-line-through text-secondary">
                {{ currency }}{{ p.discountPrice }}
              </span>
            <td>
              <img
                *ngIf="p.imageURL"
                [src]="p.imageURL"
                class="img-thumbnail"
                style="max-width:48px"
              />
              <img *ngIf="!p.imageURL" src="/assets/static/missing-image.png" />
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="filtersUsed && !filterLoading" class="d-flex justify-content-center align-items-center gap-2 mt-3">
        <button class="btn btn-link" (click)="prevPage()" [disabled]="!hasPrev">
          ⬅ {{ 'PREVIOUS' | translate }}
        </button>

        <ng-container *ngFor="let p of pages">
          <button
            *ngIf="p !== '…'"
            class="btn"
            [class.btn-outline-secondary]="(filters.counter + 1) !== p"
            [class.btn-info]="(filters.counter + 1) === p"
            (click)="goToPage(p)"
          >
            {{ p }}
          </button>
          <span *ngIf="p === '…'" class="px-2">…</span>
        </ng-container>
        <button class="btn btn-link" (click)="nextPage()" [disabled]="!hasNext">
          {{ 'NEXT' | translate }} ➡
        </button>
      </div>
    </div>

    <div class="container-price"> 
      <div class="form-card">
        <h1 class="title"> {{'PRICE' | translate}}</h1>
        <div class="form-group-container top-container">
          <div class="form-group trio">
            <label class="form-label" for="product_cost"> {{'COST_PRICE' | translate}}</label>
            <input type="number" min="0" class="form-control" id="product_cost" name="cost" placeholder="0.00"
              value="{{product.baseCost}}" (input)="changeBaseCost($event)" [disabled]="inputsDisabled" />
          </div>
          <div class="form-group trio">
            <label class="form-label" for="product_gainmargin"> {{'MARGIN' | translate}}</label>
            <input type="number" min="0" class="form-control" id="product_gainmargin" name="gainmargin" placeholder="0%"
              value="{{product.gainMargin}}" (input)="changeGainMargin($event)" [disabled]="inputsDisabled" />
          </div>
          <div class="form-group trio">
            <label class="form-label is-required" for="product_tax"> {{'TAX' | translate}}</label>
            <select class="form-select" id="product_tax" name="tax" (change)="changeTax($event)"
              [disabled]="inputsDisabled" *ngIf="taxActive?.taxCode == 1">
              <option value="" disabled selected hidden>{{'SELECT_OPTION' | translate}}</option>
              <option *ngFor="let tax of taxes, let last = last" [value]="tax.taxId" >
                {{ tax.taxName }}
              </option>
            </select>
            <select class="form-select" id="product_tax" name="tax" (change)="changeTax($event)"
              [disabled]="inputsDisabled" *ngIf="taxActive?.taxCode == 0">
              <option selected value="taxActive.taxId">{{taxActive.taxName}}</option>
            </select>
            <p id="product_revenue" *ngIf="product.baseCost > 0 && product.sellPrice > 0 && product.taxId > 0">
              {{currency}}{{revenueValue()}}
            </p>
            <p id="product_revenue" *ngIf="product.taxId == 0">
              {{currency}}0
            </p>
          </div>
        </div>
        <hr class="page-separator">
        <div class="form-group-container gap-2">
          <div class="form-group trio">
            <label class="form-label is-required" for="product_endprice"> {{'SALE_PRICE' | translate}}</label>
            <input type="number" min="0" class="form-control" id="product_endprice" name="endprice" placeholder="Precio final"
              value="{{product.sellPrice || 0}}" (input)="changeSellPrice($event)" />
          </div>
          <div class="form-group trio">
            <label class="form-label" for="product_sale"> {{'DISCOUNT_PRICE' | translate}}</label>
            <input type="number" min="0" class="form-control" id="product_sale" name="sale" placeholder="0" value="0" (input)="changeDiscountPrice($event)" />
          </div>
          <div *ngIf="productType === 4" class="form-group trio">
            <div class="d-flex align-items-center flex-column">
              <label class="form-label w-auto col-md-3">
                {{ 'SUGGESTED_PRICE' | translate }} 
              </label>
              <strong class="form-label w-auto col-md-3">
                {{ currency }}{{ totalPackagePrice }}
              </strong>
            </div>
          </div>          
          <div class="form-group trio">
            <input class="form-check-input" type="checkbox" id="hidePrice" [(ngModel)]="product.hidePrice">
            <label class="form-check-label mx-2 " for="hidePrice">
              {{'HIDE_PRICE_TO_CUSTOMER' | translate}}
            </label>
          </div>
        </div>
        <div class="form-group-container gap-2">
          <div class="form-group trio">
            <label class="form-label is-required" for="productPaymentType"> {{'PAYMENT_MODE' | translate}}</label>
            <select class="form-select" id="productPaymentType" name="tax" (change)="changePaymentMode($event)">
              <option value="1" selected>{{'ONE_TIME_PAYMENT' | translate}}Pago único</option>
              <option value="2" >{{'RECURRENT_PAYMENT' | translate}}Pago Recurrente</option>
            </select>
          </div>
          <div class="form-group trio" *ngIf="productType == 2">
            <label class="form-label is-required" for="productPaymentType"> {{'CONTRIBUTION' | translate}}</label>
            <input class="form-control" id="product_contribution" name="contribution" placeholder="0" value="0" (input)="changeContribution($event)" type="number" min="0"/>
          </div>
          <div class="form-group trio" *ngIf="productType == 2">

          </div>
        </div>
      </div>

      <div class="container-product-type" *ngIf="productType == 2">
        <h1 class="title">{{'QUANTITY' | translate}}</h1>
        <div class="form-card">
          <div class="form-group-container">
            <div class="form-group trio">
              <label class="form-label" for="product_quantity">{{'BRANCH' | translate}}</label>
              <select class="form-select mb-0" [(ngModel)]="activeNoVariantsShopPoint" (change)="changeNoVariantsShopPoint()">
                <option value="0" selected>{{'ALL' | translate}}</option>
                <option *ngFor="let shopPoint of shopPoints" [value]="shopPoint.shopPointId">{{shopPoint.shopPointName}}</option>
              </select>
            </div>
            <div class="form-group trio">
              <div class="noVariantsQuantities">
                <label class="form-label" for="product_quantity"> {{'QUANTITY_PRODUCT' | translate}}</label>
                <input class="form-control mb-0 no-variant-quantity quantityMain" type="text" min="0" [attr.data-shopPointId]="0" value="0" disabled>
                <!-- <input *ngFor="let shopPoint of shopPoints" class="form-control mb-0 visually-hidden no-variant-quantity" type="number" min="0" [attr.data-shopPointId]="shopPoint.shopPointId" hidden> -->
                <div class="shop-points-quantities" *ngFor="let shopPoint of shopPoints">
                  <select class="form-control mb-0 visually-hidden no-variant-unlimited" [attr.data-shopPointId]="shopPoint.shopPointId" (change)="onUnlimitedChange($event)">
                    <option value="0">{{'LIMITED' | translate}}</option>
                    <option value="1">{{'UNLIMITED' | translate}}</option>
                  </select>
                  <input
                  type="number"
                  class="form-control mb-0 visually-hidden no-variant-quantity"
                  [attr.data-shopPointId]="shopPoint.shopPointId"
                  value="0"
                  />
                </div>
              </div>
            </div>
            <div class="form-group trio">
              <label class="form-label is-required" for="product_sessions">{{'SESSIONS' | translate}}</label>
              <input type="number" min="0" class="form-control mb-0 ng-pristine ng-valid ng-touched" id="product_sessions" name="name" placeholder="Cantidad de sesiones" value="{{product.sessions}}" (keyup)="changeSessions($event)"/>
            </div>
          </div>
          <small class="form-text text-muted"><strong class="text-danger">*</strong>{{'UNLIMITED_HELP_TEXT' | translate}}</small>
        </div>
      </div>
      <div class="container-quantity" id="container-quantity" *ngIf="productType == 4">
        <h1 class="title"> {{'QUANTITY' | translate}}</h1>
        <div class="form-card">
          <div class="form-group-container">
            <div class="form-group couple">
              <label class="form-label" for="product_quantity">{{'BRANCH' | translate}}</label>
              <select class="form-select mb-0" [(ngModel)]="activeNoVariantsShopPoint" (change)="changeNoVariantsShopPoint()">
                <option value="0" selected>{{'ALL' | translate}}</option>
                <option *ngFor="let shopPoint of shopPoints" [value]="shopPoint.shopPointId">{{shopPoint.shopPointName}}</option>
              </select>
            </div>
            <div class="form-group couple">
              <div class="noVariantsQuantities">
                <label class="form-label" for="product_quantity"> {{'QUANTITY_PRODUCT' | translate}}</label>
                <input class="form-control mb-0 no-variant-quantity quantityMain" type="" min="0" [attr.data-shopPointId]="0" value="0" disabled>
                <input *ngFor="let shopPoint of shopPoints" class="form-control mb-0 visually-hidden no-variant-quantity" type="number" min="0" value="0" [attr.data-shopPointId]="shopPoint.shopPointId">
              </div>
            </div>
              <!-- <label class="form-label" for="product_quantity">Cantidad del producto</label>
              <input class="form-control mb-0" type="number" min="0" id="product_quantity"> -->
          </div>
          <div class="form-group-container" *ngIf="productType == 4">
            <div class="form-group trio">
              <div class="">
                <label class="form-label"> {{'PRODUCT_BENEFICIARIES' | translate}}</label>
                <input class="form-control mb-0" type="number" min="0" value="0" [(ngModel)]="productBeneficiaries">
              </div>
            </div>
              <!-- <div class="form-group trio">
                <div>
                  <label class="form-label" for="product_sessions">{{'SESSIONS' | translate}}</label>
                  <input type="number" min="0" class="form-control mb-0 ng-pristine ng-valid ng-touched" id="product_sessions" name="name" placeholder="Cantidad de sesiones" value="{{product.sessions}}" (keyup)="changeSessions($event)"/>
                </div>
              </div> -->
            <div class="form-group trio">
              <div><label class="form-label" for="product_status">{{'REQUIRED_HOLDER' | translate}}</label></div>
              <div class="switch">
                <label class="switch-label">
                  <input type="checkbox" [(ngModel)]="productHolder"/>
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
          <div *ngIf="productType == 4" class="form-group single">
            <label class="form-label">Selecciona los Parentescos</label>
            <div class="form-check-group">
              <div *ngFor="let relation of relationshipOptions">
                <input
                  type="checkbox"
                  class="form-check-input"
                  [value]="relation"
                  (change)="toggleRelationship(relation)">
                <label class="form-check-label">{{ relation }}</label>
              </div>
            </div>
          </div>

          <small class="form-text text-muted" [innerHTML]="'PRODUCTS_WITHOUT_VARIANTS_NOTE' | translate"></small>
        </div>
      </div>
      <div class="container-quantity" id="container-quantity" *ngIf="productType == 1 || productType == 3">
        <h1 class="title"> {{'QUANTITY' | translate}}</h1>
        <div class="form-card">
          <div class="form-group-container">
            <div class="form-group couple">
              <label class="form-label" for="product_quantity">{{'BRANCH' | translate}}</label>
              <select class="form-select mb-0" [(ngModel)]="activeNoVariantsShopPoint" (change)="changeNoVariantsShopPoint()">
                <option value="0" selected>{{'ALL' | translate}}</option>
                <option *ngFor="let shopPoint of shopPoints" [value]="shopPoint.shopPointId">{{shopPoint.shopPointName}}</option>
              </select>
            </div>
            <div class="form-group couple">
              <div class="noVariantsQuantities">
                <label class="form-label" for="product_quantity"> {{'QUANTITY_PRODUCT' | translate}}</label>
                <input class="form-control mb-0 no-variant-quantity quantityMain" type="" min="0" [attr.data-shopPointId]="0" value="0" disabled>
                <input *ngFor="let shopPoint of shopPoints" class="form-control mb-0 visually-hidden no-variant-quantity" type="number" min="0" value="0" [attr.data-shopPointId]="shopPoint.shopPointId">
              </div>
            </div>
              <!-- <label class="form-label" for="product_quantity">Cantidad del producto</label>
              <input class="form-control mb-0" type="number" min="0" id="product_quantity"> -->
          </div>
          <div class="form-group-container" *ngIf="productType == 3">
            <div class="form-group couple">
              <div class="">
                <label class="form-label"> {{'PRODUCT_BENEFICIARIES' | translate}}</label>
                <input class="form-control mb-0" type="number" min="0" value="0" [(ngModel)]="productBeneficiaries">
              </div>
            </div>
            <div class="form-group couple">
              <div><label class="form-label" for="product_status">{{'REQUIRED_HOLDER' | translate}}</label></div>
              <div class="switch">
                <label class="switch-label">
                  <input type="checkbox" [(ngModel)]="productHolder"/>
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
          <div *ngIf="productType === 3" class="form-group single">
            <label class="form-label">Selecciona los Parentescos</label>
            <div class="form-check-group">
              <div *ngFor="let relation of relationshipOptions">
                <input
                  type="checkbox"
                  class="form-check-input"
                  [value]="relation"
                  (change)="toggleRelationship(relation)">
                <label class="form-check-label">{{ relation }}</label>
              </div>
            </div>
          </div>

          <small class="form-text text-muted" [innerHTML]="'PRODUCTS_WITHOUT_VARIANTS_NOTE' | translate"></small>
        </div>
      </div>
    </div>


      <div class="container-variables" *ngIf="productType == 1 || productType == 3 || productType == 4">

        <div class="switch-title-container">
          <h1 class="title"> {{'VARIANTS' | translate}}</h1>
          <label class="form-check-label switch" for="flexCheckDefault">
            <input class="form-check-input" type="checkbox" id="flexCheckDefault" [checked]="areVariablesChecked"
              (change)="variablesHidden($event)">
            <span class="slider round"></span>
          </label>
        </div>

        <div [hidden]="hiddenVar1">
          <div class="form-card">

            <!-- <div class="form-label">Imágenes:</div>
          <div class="images-container">
            <div cdkDropList cdkDropListOrientation="horizontal" class="image-list" (cdkDropListDropped)="drop($event)">
              <div class="image-box" *ngFor="let image of productImages.small; let i = index" [cdkDragDisabled]="false"
                cdkDrag>
                <div class="image-placeholder" *cdkDragPlaceholder></div>
                <img [src]="image.imageURL" />
                <button type="button" class="btn btn-danger delete-button" (click)="deletePhoto(i)">
                  x
                </button>
                <button type="button" class="btn btn-link download-button" (click)="downloadImage(i)">
                  <i class="feather" data-feather="download"></i>
                </button>
              </div>
              <div class="image-box" cdkDragDisabled>
                <button class="add-img" (click)="uploadImage()">+</button>
              </div>
            </div>
          </div> -->

            <div id="formVar1" class="variant-container">
              <div>
                <label class="form-label" for="product_variable_type">
                   {{'TYPE' | translate}}
                </label>
                <input list="product_variable_type1" name="varieble_type" class="form-control"
                  placeholder="{{'ENTER_TYPE' | translate}}" id="variantTypes1" />
                <datalist id="product_variable_type1">
                  <option value="Tamaño">
                  <option value="Color">
                  <option value="Material">
                  <option value="Estilo">
                </datalist>
              </div>
              <div class="value-label">
                <label class="form-label" for="product_variable_value"> {{'VALUE' | translate}}</label>
                <button id="valBtn1" type="button" class="btn btn-outline-secondary  small-btn confirm-btn"
                  (click)="counterVariableInputs1 = addInput('formVar1', 'valBtn1', counterVariableInputs1); showBtn('delVariantBtn', counterVariableInputs1, 'formVar1')">
                  <i class="feather" data-feather="plus"></i>
                </button>
              </div>
            </div>
            <div class="delete-btn-container">
              <button type="button" class="btn btn-outline-secondary cancel-btn" (click)=" varBlock1(); counterVariableInputs1=removeElementsByClass('variantValueInput',
              counterVariableInputs1, 'valBtn1' )">
                {{'DELETE_VARIANT' | translate}}
              </button>
            </div>
          </div>
        </div>

        <div [hidden]="hiddenVar2">
          <div class="form-card">

            <!-- <div class="form-label">Imágenes:</div>
                <div class="images-container">
                  <div cdkDropList cdkDropListOrientation="horizontal" class="image-list" (cdkDropListDropped)="drop($event)">
                    <div class="image-box" *ngFor="let image of productImages.small; let i = index" [cdkDragDisabled]="false"
                      cdkDrag>
                      <div class="image-placeholder" *cdkDragPlaceholder></div>
                      <img [src]="image.imageURL" />
                      <button type="button" class="btn btn-danger delete-button" (click)="deletePhoto(i)">
                        x
                      </button>
                      <button type="button" class="btn btn-link download-button" (click)="downloadImage(i)">
                        <i class="feather" data-feather="download"></i>
                      </button>
                    </div>
                    <div class="image-box" cdkDragDisabled>
                      <button class="add-img" (click)="uploadImage()">+</button>
                    </div>
                  </div>
                </div> -->

            <div id="formVar2" class="variant-container">
              <div>
                <label class="form-label" for="product_variable_type">
                   {{'TYPE' | translate}}
                </label>
                <input list="product_variable_type2" name="varieble_type" class="form-control"
                  placeholder="{{'ENTER_TYPE' | translate}}" id="variantTypes2" />
                <datalist id="product_variable_type2">
                  <option value="Tamaño">
                  <option value="Color">
                  <option value="Material">
                  <option value="Estilo">
                </datalist>
              </div>
              <div class="value-label">
                <label class="form-label" for="product_variable_value"> {{'VALUE' | translate}}</label>
                <button id="valBtn2" type="button" class="btn btn-outline-secondary  small-btn confirm-btn"
                  (click)="counterVariableInputs2 = addInput('formVar2', 'valBtn2', counterVariableInputs2); showBtn('delVariantBtn', counterVariableInputs2, 'formVar2')">
                  <i class="feather" data-feather="plus"></i>
                </button>
              </div>
            </div>
            <div class="delete-btn-container">
              <button type="button" class="btn btn-outline-secondary cancel-btn" (click)=" varBlock2(); counterVariableInputs2=removeElementsByClass('variantValueInput',
                    counterVariableInputs2, 'valBtn2' )">
                 {{'DELETE_VARIANT' | translate}}
              </button>
            </div>

          </div>
        </div>

        <div [hidden]="hiddenVar3">
          <div class="form-card">

            <!-- <div class="form-label">Imágenes:</div>
                <div class="images-container">
                  <div cdkDropList cdkDropListOrientation="horizontal" class="image-list" (cdkDropListDropped)="drop($event)">
                    <div class="image-box" *ngFor="let image of productImages.small; let i = index" [cdkDragDisabled]="false"
                      cdkDrag>
                      <div class="image-placeholder" *cdkDragPlaceholder></div>
                      <img [src]="image.imageURL" />
                      <button type="button" class="btn btn-danger delete-button" (click)="deletePhoto(i)">
                        x
                      </button>
                      <button type="button" class="btn btn-link download-button" (click)="downloadImage(i)">
                        <i class="feather" data-feather="download"></i>
                      </button>
                    </div>
                    <div class="image-box" cdkDragDisabled>
                      <button class="add-img" (click)="uploadImage()">+</button>
                    </div>
                  </div>
                </div> -->

            <div id="formVar3" class="variant-container">
              <div>
                <label class="form-label" for="product_variable_type">
                  {{'TYPE' | translate}}
                </label>
                <input list="product_variable_type3" name="varieble_type" class="form-control"
                  placeholder="{{'ENTER_TYPE' | translate}}" id="variantTypes3" />
                <datalist id="product_variable_type1">
                  <option value="Tamaño">
                  <option value="Color">
                  <option value="Material">
                  <option value="Estilo">
                </datalist>
              </div>
              <div class="value-label">
                <label class="form-label" for="product_variable_value"> {{'VALUE' | translate}}</label>
                <button id="valBtn3" type="button" class="btn btn-outline-secondary  small-btn confirm-btn"
                  (click)="counterVariableInputs3 = addInput('formVar3', 'valBtn3', counterVariableInputs3); showBtn('delVariantBtn', counterVariableInputs3, 'formVar3')">
                  <i class="feather" data-feather="plus"></i>
                </button>
              </div>
            </div>
            <div class="delete-btn-container">
              <button type="button" class="btn btn-outline-secondary cancel-btn" (click)=" varBlock3(); counterVariableInputs3=removeElementsByClass('variantValueInput',
                    counterVariableInputs3, 'valBtn3' )">
                {{'DELETE_VARIANT' | translate}}
              </button>
            </div>

          </div>
        </div>

        <div class="variant-actions-container">
          <button type="button" class="btn btn-outline-secondary confirm-btn" (click)="showVariables()"
            [hidden]="!areVariablesChecked" [disabled]="variableButtonDisabled()">
            {{'ADD_VARIANT' | translate}}
          </button>
          <button type="button" class="btn btn-outline-secondary submit-btn" *ngIf="false"
            (click)="createItemList()">
             {{'CREATE_LIST_VARIANTS' | translate}}
          </button>
        </div>

      </div>

      <div class="form-card" [hidden]="!displayItemsTable">
        <div class="d-flex justify-content-end align-items-center">
          <div>
          <select class="form-select" [(ngModel)]="activeShopPoint" (change)="showShopPoint()">
            <option value="0" selected>{{'ALL_BRANCHS' | translate}}</option>
            <option *ngFor="let shopPoint of shopPoints" [value]="shopPoint.shopPointId">{{shopPoint.shopPointName}}</option>
          </select>
          </div>
        </div>
        <h1 class="variantsTitle" >{{'LIST_VARIANTS' | translate}}</h1>
        <div id="itemCombinationList">
        </div>
      </div>

      <div class="form-buttons">
        <button type="button" class="btn btn-outline-secondary submit-btn" (click)="createProduct()"
          [disabled]="inputsDisabled">
           {{'CREATE' | translate}}
        </button>
      </div>
    </div>
  </div>

  <app-confirmation-modal *ngIf="saveProduct" [title]="'Producto creado con éxito'"
    [confirmText]="'Ir a la lista de productos'" [twoFieldModal]="false" (response)="goBack($event)">
    ></app-confirmation-modal>

    <div class="modal product-modal" id="createProductModal" tabindex="-1">
      <div class="modal-dialog product-modal-dialog" role="document">
        <div class="modal-content product-modal-content">
          <div class="modal-body product-modal-body">
            <div class="loading">
              <div class="spinner-border" role="status"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" id="createValidationModal" tabindex="-1">
      <div class="modal-dialog product-modal-dialog" role="document">
        <div class="modal-content product-modal-content">
          <div class="modal-body product-modal-body">
            <h3 class="text-center"> {{'PRODUCT_NOT_CREATED' | translate}}</h3>
            <p class="text-center">{{'COMPLETE_REQUIRED_FIELDS' | translate}}</p>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button type="button" class="btn btn-danger cancel-btn" (click)="closeModal()"> {{'CLOSE' | translate}}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal error-confirm-modal fade" id="errorCreateModal" tabindex="-1">
      <div class="modal-dialog error-modal-dialog" role="document">
        <div class="modal-content error-modal-content">
          <div class="modal-body error-modal-body">
            <h3 class="text-center"> {{'ERROR' | translate}}</h3>
            <p class="text-center">{{'PRODUCT_CREATION_ERROR' | translate}}</p>
          </div>
          <div class="modal-buttons">
            <button type="button" class="btn btn-confirm" (click)="closeModal()"> {{'CLOSE' | translate}}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal error-confirm-modal fade" id="errorProductModal" tabindex="-1">
      <div class="modal-dialog error-modal-dialog" role="document">
        <div class="modal-content error-modal-content">
          <div class="modal-body error-modal-body">
            <h3 class="text-center">{{"ERROR" | translate}}</h3>
            <p class="text-center">{{'MAX_SIZES' | translate}}</p>
          </div>
          <div class="modal-buttons">
            <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
